mutation IntegrationFormSubmit($input: IntegrationFormSubmitInput!) {
    integrationFormSubmit(input: $input) {
        success
    }
}
